<ds-thumbnail *ngIf="(initialized | async)" data-test="thumbnail"
              [thumbnail]="thumbnail$ | async"
              [defaultImage]="default$ | async">
</ds-thumbnail>
